<template>
  <div>
    <v-card class="pa-6 rounded-lg" elevation="2">
      <div class="d-flex align-center justify-space-between mb-6">
        <div class="d-flex align-center">
          <v-icon color="#F4811F" size="32" class="mr-3">mdi-tag-multiple</v-icon>
          <h2 class="text-h5 font-weight-bold">ตั้งค่าโปรโมชั่น (เครดิตรายวัน)</h2>
        </div>
        <div class="d-flex gap-2">
          <v-btn
            outlined
            color="#F4811F"
            :loading="triggering"
            @click="triggerNow"
          >
            <v-icon left>mdi-play-circle-outline</v-icon>
            รันแจกเครดิตทันที
          </v-btn>
          <v-btn color="#F4811F" dark depressed class="ml-2" @click="openCreate">
            <v-icon left>mdi-plus</v-icon>
            เพิ่มโปรโมชั่น
          </v-btn>
        </div>
      </div>

      <v-divider class="mb-4" />

      <div class="setting-sub mb-4">
        ระบบจะแจก <b>promoBalance</b> ให้ seller และ rider ทุกวันเวลา 00:01 น.
        โดยเงินโปรใช้หักค่าธรรมเนียม 10% ได้ แต่ <b>ถอนออกไม่ได้</b>
      </div>

      <v-data-table
        :headers="headers"
        :items="promotions"
        :loading="loading"
        no-data-text="ยังไม่มีโปรโมชั่น"
        hide-default-footer
        class="rounded-lg"
      >
        <template v-slot:[`item.startDate`]="{ item }">
          {{ formatDate(item.startDate) }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          {{ formatDate(item.endDate) }}
        </template>
        <template v-slot:[`item.sellerDailyAmount`]="{ item }">
          {{ item.sellerDailyAmount > 0 ? `฿${item.sellerDailyAmount}/วัน` : '-' }}
        </template>
        <template v-slot:[`item.riderDailyAmount`]="{ item }">
          {{ item.riderDailyAmount > 0 ? `฿${item.riderDailyAmount}/วัน` : '-' }}
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip
            small
            :color="item.isActive ? '#198C19' : '#9E9E9E'"
            dark
          >
            {{ item.isActive ? 'เปิดใช้งาน' : 'ปิด' }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon small @click="openEdit(item)">
            <v-icon size="18" color="#F4811F">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon small @click="confirmDelete(item)">
            <v-icon size="18" color="#EE2526">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog สร้าง/แก้ไข -->
    <v-dialog v-model="dialog" max-width="520" persistent>
      <v-card class="pa-6 rounded-lg">
        <h3 class="text-h6 font-weight-bold mb-4">
          {{ editItem ? 'แก้ไขโปรโมชั่น' : 'เพิ่มโปรโมชั่น' }}
        </h3>

        <v-text-field
          v-model="form.name"
          label="ชื่อโปรโมชั่น"
          outlined
          dense
          class="mb-2"
        />

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model="form.startDate"
              label="วันเริ่ม"
              type="date"
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.endDate"
              label="วันสิ้นสุด"
              type="date"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.sellerDailyAmount"
              label="เครดิต Seller / วัน (฿)"
              type="number"
              min="0"
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model.number="form.riderDailyAmount"
              label="เครดิต Rider / วัน (฿)"
              type="number"
              min="0"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <v-switch
          v-model="form.isActive"
          label="เปิดใช้งาน"
          color="#F4811F"
          inset
          dense
        />

        <div class="d-flex justify-end gap-2 mt-2">
          <v-btn text @click="dialog = false">ยกเลิก</v-btn>
          <v-btn
            color="#F4811F"
            dark
            depressed
            :loading="saving"
            @click="save"
          >
            บันทึก
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminSettingsService from "@/services/api/adminSettings";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "AdminPromotionSettings",
  data() {
    return {
      loading: false,
      saving: false,
      triggering: false,
      promotions: [],
      dialog: false,
      editItem: null,
      form: this.emptyForm(),
      headers: [
        { text: "ชื่อ",              value: "name",               sortable: false },
        { text: "วันเริ่ม",           value: "startDate",          sortable: false },
        { text: "วันสิ้นสุด",          value: "endDate",            sortable: false },
        { text: "เครดิต Seller/วัน",  value: "sellerDailyAmount",  sortable: false },
        { text: "เครดิต Rider/วัน",   value: "riderDailyAmount",   sortable: false },
        { text: "สถานะ",              value: "isActive",           sortable: false },
        { text: "",                   value: "actions",            sortable: false, align: "end" },
      ],
    };
  },
  async created() {
    await this.load();
  },
  methods: {
    emptyForm() {
      return { name: "", startDate: "", endDate: "", sellerDailyAmount: 0, riderDailyAmount: 0, isActive: true };
    },
    formatDate(d) {
      if (!d) return "-";
      return new Date(d).toLocaleDateString("th-TH", { day: "2-digit", month: "2-digit", year: "numeric" });
    },
    async load() {
      this.loading = true;
      try {
        const res = await AdminSettingsService.listPromotions();
        this.promotions = res.data?.promotions || [];
      } catch (e) {
        swalAlert.Error("โหลดข้อมูลไม่สำเร็จ", e?.response?.data?.message);
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editItem = null;
      this.form = this.emptyForm();
      this.dialog = true;
    },
    openEdit(item) {
      this.editItem = item;
      this.form = {
        name:              item.name,
        startDate:         item.startDate?.slice(0, 10),
        endDate:           item.endDate?.slice(0, 10),
        sellerDailyAmount: item.sellerDailyAmount,
        riderDailyAmount:  item.riderDailyAmount,
        isActive:          item.isActive,
      };
      this.dialog = true;
    },
    async save() {
      if (!this.form.name || !this.form.startDate || !this.form.endDate) {
        return swalAlert.Error("กรุณากรอกข้อมูลให้ครบ");
      }
      this.saving = true;
      try {
        if (this.editItem) {
          await AdminSettingsService.updatePromotion(this.editItem.id, this.form);
        } else {
          await AdminSettingsService.createPromotion(this.form);
        }
        this.dialog = false;
        await swalAlert.Success("บันทึกสำเร็จ");
        await this.load();
      } catch (e) {
        swalAlert.Error("บันทึกไม่สำเร็จ", e?.response?.data?.message);
      } finally {
        this.saving = false;
      }
    },
    async confirmDelete(item) {
      const result = await swalAlert.Confirm(`ลบโปรโมชั่น "${item.name}" ใช่ไหม?`);
      if (!result?.isConfirmed) return;
      try {
        await AdminSettingsService.deletePromotion(item.id);
        await swalAlert.Success("ลบสำเร็จ");
        await this.load();
      } catch (e) {
        swalAlert.Error("ลบไม่สำเร็จ", e?.response?.data?.message);
      }
    },
    async triggerNow() {
      const result = await swalAlert.Confirm("แจก promoBalance ให้ทุก seller และ rider ทันทีใช่ไหม?");
      if (!result?.isConfirmed) return;
      this.triggering = true;
      try {
        const res = await AdminSettingsService.triggerPromotion();
        await swalAlert.Success(`แจกเครดิตสำเร็จ ${res.data?.credited ?? 0} กระเป๋า`);
      } catch (e) {
        swalAlert.Error("รันไม่สำเร็จ", e?.response?.data?.message);
      } finally {
        this.triggering = false;
      }
    },
  },
};
</script>

<style scoped>
.setting-sub {
  font-size: 13px;
  color: #6b717f;
}
</style>
